import React, { Suspense, lazy } from 'react'
import { Modal } from '@web/walter-ui-kit'
import { useModal } from '~contexts/ModalsContext'
import { ModalTypes } from '~contexts/ModalsContext/types'
import SuspenseLoader from '~components/SuspenseLoader'

const Content = lazy(() => import('./Content'))

function StakingModal() {
    const { isOpen, hide } = useModal(ModalTypes.staking)

    const onClose = () => {
        hide()
    }

    return (
        <Modal dataPointer="staking_modal" isOpen={isOpen} onClose={onClose} type="dialog">
            <Suspense fallback={<SuspenseLoader type="modal" />}>
                <Content />
            </Suspense>
        </Modal>
    )
}

export default StakingModal
